import { FormattedNumber, useIntl } from 'react-intl';

import { FiatCurrency } from '@sorare/core/src/__generated__/globalTypes';
import { qualityNames } from '@sorare/core/src/lib/players';
import {
  RewardType,
  RewardWithExperiencesType,
  SimpleReward,
} from '@sorare/core/src/lib/rewards';

type Props = Pick<SimpleReward, 'count' | 'quality'> & {
  type: RewardWithExperiencesType;
};

export const RewardOverviewTitle = ({ type, count, quality }: Props) => {
  const { formatNumber } = useIntl();

  const formattedCount = formatNumber(count, {
    maximumFractionDigits: 1,
    notation: 'compact',
    compactDisplay: 'short',
  });

  switch (type) {
    case RewardType.CASH:
    case RewardType.CREDIT:
      return (
        <FormattedNumber
          value={count}
          style="currency"
          currency={FiatCurrency.USD}
          currencyDisplay="narrowSymbol"
          maximumFractionDigits={0}
        />
      );
    default:
      if (type === RewardType.CARD && quality) {
        return `${count > 1 ? `x${formattedCount} ` : ''}${qualityNames[quality]}`;
      }
      return `x${formattedCount}`;
  }
};
